import { useEffect, useState } from "react";
import axios from "axios";
import RoomCanvas from "./RoomCanvas";
import RoundTable from "./RoundTable";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const Seating = () => {
  const [data, setData] = useState({ published: false, tables: [], furniture: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API}/seating`);
        setData(res.data || { published: false, tables: [], furniture: [] });
      } catch {
        // ignore
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading || !data.published || !(data.tables || []).length) return null;

  const hasPositions = (data.tables || []).some(
    (t) => typeof t.x === "number" && typeof t.y === "number" && (t.x || t.y)
  );

  return (
    <section
      id="tischplan"
      data-testid="section-seating"
      className="py-24 md:py-36 bg-sage-50"
    >
      <div className="container mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <p className="text-sage-500 uppercase tracking-[0.35em] text-xs mb-6">
            · Sitzordnung ·
          </p>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-sage-800">
            Wer sitzt{" "}
            <span className="font-script text-sage-500 text-5xl sm:text-6xl lg:text-7xl">
              wo
            </span>
          </h2>
          <p className="mt-6 text-sage-600 max-w-xl mx-auto">
            Hier findet ihr eure Plätze. Klickt bzw. tippt auf einen Tisch, um die
            Namen zu sehen.
          </p>
        </div>

        {hasPositions ? (
          <div className="max-w-6xl mx-auto">
            <RoomCanvas
              tables={data.tables}
              furniture={data.furniture || []}
              readOnly
            />
            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {data.tables.map((t) => (
                <div
                  key={t.id}
                  data-testid={`public-table-legend-${t.id}`}
                  className="bg-white border border-sage-200 rounded-xl p-4"
                >
                  <h3 className="font-serif text-lg text-sage-800">{t.name}</h3>
                  <p className="text-xs text-sage-500 mb-2">
                    {(t.assignments || []).filter(Boolean).length} / {t.seats} Plätze
                  </p>
                  <ul className="text-sm text-sage-700 space-y-0.5">
                    {(t.assignments || [])
                      .filter(Boolean)
                      .map((n, i) => (
                        <li key={i}>· {n}</li>
                      ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="flex flex-wrap justify-center gap-10 md:gap-14">
            {data.tables.map((t) => (
              <div
                key={t.id}
                data-testid={`public-table-${t.id}`}
                className="flex flex-col items-center gap-3"
              >
                <RoundTable table={t} size={260} />
                <div className="text-center">
                  <h3 className="font-serif text-xl text-sage-800">{t.name}</h3>
                  <p className="text-xs text-sage-500">
                    {(t.assignments || []).filter(Boolean).length} / {t.seats} Plätze belegt
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}

        <p className="text-center mt-14 text-xs text-sage-500">
          Tipp: Auf jedem Sitzplatz liegt eine Karte mit eurem Namen.
        </p>
      </div>
    </section>
  );
};

export default Seating;
